<div fxLayout="column">
  {{ data.name }} Notes/Regression

  <mat-form-field style="margin-top: 10px; width: 100%;" floatLabel="never">
    <textarea matInput [(ngModel)]="notes" placeholder="Type here..." [disabled]="!data.canEdit"></textarea>
  </mat-form-field>

  <div fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button color="primary" (click)="close()">Close</button>
  </div>
</div>
